import { BE_ADMIN_BASE } from "./environment";
import { apiGet, apiPost } from "./apiClient";

export const getDropnetLocationsAPI = (params, opts) => {
  const queryParts = [];
  if (params?.region) queryParts.push(`region=${encodeURIComponent(params.region)}`);
  if (params?.country) queryParts.push(`country=${encodeURIComponent(params.country)}`);
  const query = queryParts.length ? `?${queryParts.join("&")}` : "";
  return apiGet(`${BE_ADMIN_BASE}/dropnet/locations${query}`, opts);
};

export const getDropnetRulesAPI = (opts) =>
  apiGet(`${BE_ADMIN_BASE}/dropnet`, opts);

export const getDropnetRuleByIdAPI = (payload, opts) =>
  apiPost(`${BE_ADMIN_BASE}/dropnet/view`, payload, opts);

export const updateDropnetRuleAPI = (payload, opts) =>
  apiPost(`${BE_ADMIN_BASE}/dropnet/update`, payload, opts);

export const saveDropnetRuleAPI = (payload, opts) =>
  apiPost(`${BE_ADMIN_BASE}/dropnet/save`, payload, opts);
